import { attr } from '@ember-data/model';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
export default EmberDataBaseFragment.extend({
  uid: attr('string'),
  taxUid: attr('string')
}).reopenClass({
  _modelNameForMigration: 'applied-tax'
});